/* eslint-disable no-nested-ternary */
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { convertApprovalStatus } from '../../../../../../api/enumerations';
import { formatDate } from '../../../../../../helpers';
import {
  TableCellHeader,
  StyledCell,
  StyledRow,
  StyledPagination,
  StyledTableBody,
  LoadingRow,
} from './styles';
import { CompaniesTableProps } from './types';

export function CompaniesTable({
  data,
  page,
  totalPages,
  setPage,
  isLoading = false,
}: CompaniesTableProps): JSX.Element {
  const navigate = useNavigate();

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ): void => {
    setPage(value);
  };

  const handleNavigate = (noticeId: number, noticeCompanyId: number): void => {
    navigate(`/the-hive/notices/${noticeId}/request/${noticeCompanyId}`);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCellHeader width="30%">Nome da empresa</TableCellHeader>
              <TableCellHeader width="30%" align="center">
                Data do credenciamento
              </TableCellHeader>
              <TableCellHeader width="30%" align="center">
                Responsável
              </TableCellHeader>
              <TableCellHeader width="30%" align="center">
                Status
              </TableCellHeader>
            </TableRow>
          </TableHead>
          <StyledTableBody>
            {isLoading ? (
              <LoadingRow>
                <StyledCell colSpan={4} align="center">
                  <CircularProgress size={24} />
                </StyledCell>
              </LoadingRow>
            ) : data.length === 0 ? (
              <LoadingRow>
                <StyledCell colSpan={3} align="center">
                  Nenhuma empresa encontrada
                </StyledCell>
              </LoadingRow>
            ) : (
              data.map((item) => (
                <StyledRow
                  key={item.notice_company_id}
                  onClick={() =>
                    handleNavigate(item.notice_id, item.notice_company_id)
                  }
                >
                  <StyledCell>{item.licensed_company.company.name}</StyledCell>
                  <StyledCell align="center">
                    {item.approved_at ? formatDate(item.approved_at) : '—'}
                  </StyledCell>
                  <StyledCell align="center">
                    {item.licensed_company.company.responsible_user?.name}
                  </StyledCell>
                  <StyledCell align="center">
                    {convertApprovalStatus(item.approval_status)}
                  </StyledCell>
                </StyledRow>
              ))
            )}
          </StyledTableBody>
        </Table>
      </TableContainer>
      <StyledPagination
        page={page}
        count={totalPages}
        onChange={handlePageChange}
      />
    </>
  );
}
